import React from 'react';

const PricingDetails = () => {
  return (
    <div className="pricing-details">
      <h1>Pełny cennik SiteForge AI</h1>
      <p>Szczegółowe informacje o pakietach cenowych.</p>
    </div>
  );
};

export default PricingDetails;
